import axios from 'axios';
axios.defaults.withCredentials = true;

import axiosIntance from './http.service';
import { ResponseWrapper, ErrorWrapper } from './utils';
import $store from '@/store/index';
import $router from '../../router';
import getEnv from '@/utils/env';
import axiosInstance from '@/services/api/http.service';
import { AUTO_REF_KEY } from '@/utils/constants';

const API_URL =
  getEnv('VUE_APP_AUTH_HOST') ||
  process.env.VUE_APP_AUTH_HOST ||
  'https://localhost:4000';
let BEARER = '';

export class AuthService {
  /**
   ******************************
   * @API
   ******************************
   */

  static async makeLogin({ username, pwd, rememberMe }) {
    try {
      const response = await axios.post(
        `${API_URL}/users/login`,
        {
          username,
          pwd,
          rememberMe,
        },
        { withCredentials: true },
      );

      // _setAuthData({
      //   accessToken: response.data.accessToken,
      //   exp: _parseTokenData(response.data.accessToken).exp,
      //   refreshToken: response.data.refreshToken
      // });
      // _setTeamID({
      //   teamID: _parseTokenData(response.data.accessToken).teams[0]
      // });
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async makeLogout() {
    try {
      const response = await new axiosIntance({ auth: true }).post(
        `${API_URL}/users/logout`,
        {
          //refreshToken: window.localStorage.getItem('refresh')
        },
      );
      await _resetLogoutData();
      $router
        .push({ name: 'login' })
        .then(() => {
          $store.commit('homeState/setDefaultValues', {});
        })
        .catch(() => {});
      return new ResponseWrapper(response, response.data.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async getTeamsList({ pageNo, pageSize, keyword, type }) {
    try {
      const queryParams = new URLSearchParams({
        pageNum: pageNo,
        pageSize: pageSize,
        keyword: keyword,
        ...(type && { type }), // Include `type` only if it is defined
      }).toString();
      const response = await new axiosIntance({ auth: true }).get(
        `${API_URL}/users/userTeams?${queryParams}`,
      );

      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async getTeamName(teamId) {
    try {
      const response = await new axiosIntance({ auth: true }).get(
        `${API_URL}/users/userTeams?teamId=${teamId}`,
      );
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async setCookieForTeam(teamId) {
    try {
      const response = await new axiosIntance({ auth: true }).post(
        `${API_URL}/tokens/access?teamId=${teamId}`,
      );

      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async getAccessTokenFromCodeAndState(code, state) {
    try {
      const response = await new axiosIntance({ auth: true }).get(
        `${API_URL}/sso?code=${code}&state=${state}`,
      );

      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async refreshTokens(teamId) {
    try {
      const response = await axios.post(
        `${API_URL}/tokens/access?teamId=${teamId}`,
        {},
      );
      // _setAuthData({
      //   accessToken: response.data.token,
      //   exp: _parseTokenData(response.data.token).exp,
      //   refreshToken: window.localStorage.getItem('refresh')
      // });
      // _setTeamID({
      //   teamID: _parseTokenData(response.data.token).teams[0]
      // });
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      _resetAuthData();
      $router.push({ name: 'login' }).catch(() => {});
      throw new ErrorWrapper(error);
    }
  }
  /**
   ******************************
   * @deprecated
   ******************************
   */
  static debounceRefreshTokens = this._debounce(() => {
    return this.refreshTokens();
  }, 100);

  static async sendEmail({ email }) {
    try {
      const response = await axios.post(
        `${API_URL}/users/password/request_reset`,
        {
          email,
        },
      );
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async firstPassword({ token, pwd }) {
    try {
      const response = await axios.post(`${API_URL}/users/password`, {
        token,
        pwd,
      });
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async resetPassword({ token, pwd }) {
    try {
      const response = await axios.post(`${API_URL}/users/password/reset`, {
        token,
        pwd,
      });
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async getCapabilitiesPermissions() {
    try {
      const response = await new axiosIntance({ auth: true }).get(
        `${API_URL}/resource-groups`,
      );
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async getCustomRoles({
    teamId,
    pageNum,
    pageSize,
    keyword,
    include,
    type,
  }) {
    try {
      const response = await new axiosIntance({ auth: true }).get(
        `${API_URL}/role/team/${teamId}?pageNum=${pageNum}&pageSize=${pageSize}&keyword=${keyword}&include=${include}&type=${type}`,
      );
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async getRoleById({ id, include }) {
    try {
      const response = await new axiosIntance({ auth: true }).get(
        `${API_URL}/role/${id}?include=${include}`,
      );
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async createRole({ data }) {
    try {
      const response = await new axiosIntance({ auth: true }).post(
        `${API_URL}/role`,
        data,
      );
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async updateRole({ data, id }) {
    try {
      const response = await new axiosIntance({ auth: true }).put(
        `${API_URL}/role/${id}`,
        data,
      );
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async getGroupedRoles({
    pageNum,
    pageSize,
    keyword,
    include,
    isDefaultGroup,
  }) {
    try {
      const response = await new axiosIntance({ auth: true }).get(
        `${API_URL}/group-role/billing?pageNum=${pageNum}&pageSize=${pageSize}&keyword=${keyword}&include=${include}&isDefaultGroup=${isDefaultGroup}`,
      );
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async createGroupedRoles({ data }) {
    try {
      const response = await new axiosIntance({ auth: true }).post(
        `${API_URL}/group-role`,
        data,
      );
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async updateGroupRole({ data, id }) {
    try {
      const response = await new axiosIntance({ auth: true }).put(
        `${API_URL}/group-role/${id}`,
        data,
      );
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async updateGroupRoleDefaultStatus({ data, id }) {
    try {
      const response = await new axiosIntance({ auth: true }).put(
        `${API_URL}/group-role/${id}/default/billing`,
        data,
      );
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async getGroupRoleById({ id, include }) {
    try {
      const response = await new axiosIntance({ auth: true }).get(
        `${API_URL}/group-role/${id}?include=${include}`,
      );
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  // static async getTenants({ pageNum, pageSize, keyword }) {
  //   try {
  //     const response = await axios.get(
  //       `${API_URL}/tenant?pageNum=${pageNum}&pageSize=${pageSize}&keyword=${keyword}`,
  //     );
  //     return new ResponseWrapper(response, response.data);
  //   } catch (error) {
  //     throw new ErrorWrapper(error);
  //   }
  // }

  static async deleteCustomPermission(roleId) {
    try {
      const response = await new axiosIntance({ auth: true }).delete(
        `${API_URL}/role/${roleId}`,
      );
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async deleteGroupRolePermission(roleId) {
    try {
      const response = await new axiosIntance({ auth: true }).delete(
        `${API_URL}/group-role/${roleId}`,
      );
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async getUsers({
    pageNum,
    pageSize,
    keyword,
    include,
    roleIds,
    groupRoleIds,
    roleType,
  }) {
    try {
      const response = await new axiosIntance({ auth: true }).get(
        `${API_URL}/users?pageNum=${pageNum}&pageSize=${pageSize}&keyword=${keyword}&include=${include}&roleIds=${roleIds}&groupRoleIds=${groupRoleIds}&roleType=${roleType}`,
      );
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async getUserById({ id, include }) {
    try {
      const response = await new axiosIntance({ auth: true }).get(
        `${API_URL}/users/${id}?include=${include}`,
      );
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async createUser({ data }) {
    try {
      const response = await new axiosIntance({ auth: true }).post(
        `${API_URL}/users`,
        data,
      );
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async updateUser({ data, id }) {
    try {
      const response = await new axiosIntance({ auth: true }).put(
        `${API_URL}/users/${id}`,
        data,
      );
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async deleteUser(userId) {
    try {
      const response = await new axiosIntance({ auth: true }).delete(
        `${API_URL}/users/${userId}`,
      );
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async assignRolesToUser(data) {
    try {
      const response = await new axiosIntance({ auth: true }).post(
        `${API_URL}/users/assign-roles`,
        data,
      );
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async updatePassword({ timezoneId, oldPwd, newPwd }) {
    try {
      let config = {
        headers: {
          // Authorization: 'Bearer ' + localStorage.getItem('accessToken')
        },
      };
      const response = await axios.put(
        `${API_URL}/users/password`,
        {
          timezoneId,
          oldPwd,
          newPwd,
        },
        config,
      );
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }
  static async atssaLogin(email, projectName, teamID) {
    try {
      const response = await new axiosInstance({ auth: true }).post(
        `${API_URL}/atssa/add-user`,
        {
          email: `${email}`,
          projectName: `${projectName}`,
          teamId: `${teamID}`,
          projectDesc: `Atssa for ${projectName}`,
        },
      );
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      console.log(error);
      throw new ErrorWrapper(error);
    }
  }
  /**
   ******************************
   * @METHODS
   * @deprecated
   ******************************
   */

  static isAccessTokenExpired() {
    const accessTokenExpDate = $store.state.globalState.user.tokenExp - 10;
    const nowTime = Math.floor(new Date().getTime() / 1000);

    return accessTokenExpDate <= nowTime;
  }

  static hasRefreshToken() {
    return Boolean(localStorage.getItem('refreshToken'));
  }

  static setRefreshToken(status) {
    if (!['', 'true'].includes(status)) {
      throw new Error(
        `setRefreshToken: invalid value ${status}; Expect one of ['', 'true']`,
      );
    }

    localStorage.setItem('refreshToken', status);
  }

  static getBearer() {
    return BEARER;
  }

  static setBearer(accessToken) {
    BEARER = `Bearer ${accessToken}`;
  }

  static async getPermissions() {
    const response = await new axiosInstance({ auth: true }).post(
      `${API_URL}/resource-groups/permissions?includeResources=false&all=true`,
      {
        resourceGroups: [],
      },
    );

    return Object.keys(response.data).reduce((acc, key) => {
      acc[key] = response.data[key].resourcePermissionMap;
      return acc;
    }, {});
  }
  static async fetchServicePermissions(serviceAccessList) {
    const response = await new axiosInstance({ auth: true }).post(
      `${API_URL}/resource-groups/validate`,
      serviceAccessList,
    );

    return response?.data?.reduce((permissions, item) => {
      if (item?.authorized) permissions.push(item?.permission);
      return permissions;
    }, []);
  }
  static async fetchServicesPermissions(serviceAccessList) {
    const response = await new axiosInstance({ auth: true }).post(
      `${API_URL}/resource-groups/validate`,
      serviceAccessList,
    );

    return response?.data?.reduce((permissions, item) => {
      if (item?.authorized) {
        permissions[item.resource] = permissions[item.resource] || [];
        permissions[item.resource].push(item?.permission);
      }
      return permissions;
    }, {});
  }

  /**
   * https://stackoverflow.com/questions/35228052/debounce-function-implemented-with-promises
   * @param inner
   * @param ms
   * @returns {function(...[*]): Promise<unknown>}
   * @private
   *  @deprecated
   */
  static _debounce(inner, ms = 0) {
    let timer = null;
    let resolves = [];

    return function () {
      clearTimeout(timer);
      timer = setTimeout(() => {
        const result = inner();
        resolves.forEach((r) => r(result));
        resolves = [];
      }, ms);

      return new Promise((resolve) => resolves.push(resolve));
    };
  }
}

/**
 ******************************
 * @private_methods
 *  @deprecated
 ******************************
 */

function _parseTokenData(accessToken) {
  let payload = '';
  let tokenData = {};

  try {
    payload = accessToken.split('.')[1];
    tokenData = JSON.parse(atob(payload));
  } catch (error) {
    throw new Error(error);
  }

  return tokenData;
}

function _resetAuthData() {
  window.localStorage.clear();
  $store.commit('globalState/user/setTeamId', '');
  $store.commit('globalState/user/setTeamName', '');
  $store.commit('globalState/user/setIsAuthenticated', false);
}

async function _resetLogoutData() {
  $store.commit('globalState/user/setDefaultValues', {});
  $store.commit('apmState/apmCommonState/setDefaultValues', {});
  $store.commit('browserState/browserCommonState/setDefaultValues', {});
  $store.commit('databaseState/databaseCommonState/setDefaultValues', {});
  $store.commit('mobileState/mobileCommonState/setDefaultValues', {});
  $store.commit('wsmState/wsmCommonState/setDefaultValues', {});
  $store.commit('vmState/vmCommonState/setDefaultValues', {});
  $store.commit('syntheticState/secretManager/setDefaultValues', {});
  $store.commit('syntheticState/tokenManager/setDefaultValues', {});
  $store.commit('syntheticState/commonState/setDefaultValues', {});
  $store.commit('syntheticState/endpoints/setDefaultValues', {});
  $store.commit('mqState/mqCommonState/setDefaultValues', {});
  $store.commit('logState/logCommonState/setDefaultValues', {});
  $store.commit('k8State/k8CommonState/setDefaultValues', {});
  $store.commit('alertV2State/configure/setDefaultValues', {});
  $store.commit('channelState/overview/setDefaultValues', {});
  $store.commit('alertV2State/extTagGrouping/setDefaultValues', {});
  $store.commit('alertV2State/tagGrouping/setDefaultValues', {});
  $store.commit('cloudState/services/setDefaultValues', {});
  $store.commit('databaseState/detail/setDefaultValues', {});
  $store.commit('globalState/app/setPermissions');
  let autoRef = localStorage.getItem(AUTO_REF_KEY);
  window.localStorage.clear();
  localStorage.setItem(AUTO_REF_KEY, autoRef);
}

function _setAuthData({ accessToken, exp, refreshToken } = {}) {
  $store.commit('globalState/user/setTokenExp', exp);
}
/**
 ******************************
 *  @deprecated
 ******************************
 */
function _setTeamID({ teamID } = {}) {
  $store.commit('globalState/user/setTeamId', teamID);
}
